import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWaveSquare } from '@fortawesome/pro-regular-svg-icons/faWaveSquare';

// FontAwesome regular (outlined) wave-square icon — a square-wave pulse line.
// Wrapped so it conforms to the same component-with-no-props contract as
// the other nav icons in this directory (rendered as <IconComponent />
// by NavIcon).
const StyledIcon = styled(FontAwesomeIcon)`
  height: 16px;
  width: 16px;
`;

export default function WaveSquare() {
  return <StyledIcon icon={faWaveSquare} />;
}
